import superjson from 'superjson'

export const apiTransformer = superjson
